import { Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { AccountService } from 'src/app/services/account.service';
import { OtherService } from 'src/app/services/other.service';
import html2canvas from 'html2canvas';

@Component({

  selector: 'app-payment',

  templateUrl: './payment.component.html',

  styleUrls: ['./payment.component.css']

})
export class PaymentComponent implements OnInit {

  isSuccess: boolean = true;

  message: string = '';

  obj_Payment: any = {};

  constructor(

    private otherService: OtherService,

    private toastr: ToastrService,

    private formBuilder: FormBuilder,

    private accountService: AccountService,

    private router: Router,

    private route: ActivatedRoute,

  ) { }

  ngOnInit(): void {

    this.route.queryParamMap.subscribe((query: any) => {

      if (query.params) {

        this.accountService.checkout_payment(query.params).subscribe((userData) => {

          let res = JSON.parse(userData.toString());

          if (res?.ISSessionExpired === true) {
            this.otherService.logout();
            this.router.navigate(['/'], { queryParams: { error: 'SessionExpired' } });
            this.accountService.toastSwal(
              'error',
              'نشست کاربری شما منقضی شده است، مجددا وارد سامانه شوید'
            );
          }

          this.isSuccess = res.iResult || 0;

          this.message = res.strError;

          this.obj_Payment = res;

        });

      }

    })


  }

  saveShot() {

    const element = document.getElementById('payment-receipt');

    if (!element) return;

    html2canvas(element, {

      scale: 2,

      useCORS: true,

      ignoreElements: (el) => {

        return el.classList.contains('payment-buttons');

      }

    }).then(canvas => {

      const link = document.createElement('a');

      link.download = `receipt-${this.obj_Payment?.strTransactionID}.png`;

      link.href = canvas.toDataURL('image/png');

      link.click();

    });

  }


}
